import React from "react";

const stats = [
  {
    k: "80%",
    label: "Reduction in manual tasks",
    sub: "Average time saved within the first 60 days.",
  },
  {
    k: "3×",
    label: "Faster response times",
    sub: "AI systems respond to leads in seconds, not hours.",
  },
  {
    k: "10+",
    label: "Hours saved per week",
    sub: "Per team member, through workflow automation.",
  },
  {
    k: "24/7",
    label: "We handle the AI",
    sub: "Monitored, maintained and evolved by our team, so you can focus on your business.",
  },
];


export default function Results() {
  return (
    <section id="results" className="relative py-14 sm:py-20 bg-[var(--porcelain-deep)]">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="mb-10 max-w-[820px]">
          <div>
            <span className="num-tile">Results</span>
            <h2 className="font-serif font-medium text-[var(--ink)] text-[40px] sm:text-[54px] leading-[1.05] mt-5">
              The numbers{" "}
              <span className="italic font-italic-serif text-[var(--ink-soft)]">speak</span> for
              themselves.
            </h2>
          </div>
          {/* Live analytics detail */}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={`result-stat-${i}`}
              className="lift bg-white border border-[var(--line)] rounded-2xl p-7"
            >
              <div className="font-serif text-[58px] sm:text-[64px] leading-none text-[var(--ink)]">
                {s.k}
              </div>
              <div className="mt-5 font-mono text-[10.5px] tracking-[0.18em] uppercase text-[var(--blue)]">
                {s.label}
              </div>
              <p className="mt-3 text-[13.5px] leading-[1.6] text-[var(--ink-muted)]">
                {s.sub}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-6 text-[12px] text-[var(--ink-faint)]">
          * Results based on average outcomes across Duaura client deployments.
        </p>
      </div>
    </section>
  );
}
